// extracted by mini-css-extract-plugin
export default {"page":"pY1zt","sidebar":"ml8QY","header":"c6VRp","lessonsBtn":"Ihreo"};